import React, { Component } from "react";
import {
  message,
    Spin,
    Row,
    Col,
    Divider,
    Select,
    Input,
    notification,
    Tabs,
    Modal,
    Popconfirm
} from "antd";
import {
  MensajeError,
    dineroDisabledMask,
    Form,
    FormItem,
    SelectItem,
    DatePickerItem,
    InputItem,
    ButtonItem,
    SwitchItem,
    ErrorItem,
    HeaderItem,
    BoxItem,
} from "../../../../Components/Items";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { PlusOutlined } from "@ant-design/icons";
import ElegirTipoDeCliente from "../../Clientes/ElegirTipoDeCliente/ElegirTipoDeCliente";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import MandarCorreo from "../../Ventas/MandarCorreo/MandarCorreo";
import qz from 'qz-tray';
import ticketPdf from "../../../../Pdf/ticketPdf";
import TabRelaciones from "../AgregarVenta/TabRelaciones/TabRelaciones";
import AgregarCliente from "../AgregarVenta/AgregarCliente/AgregarCliente";
import printJS from "print-js";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

moment.locale("es");

const { Option } = Select;
const { TabPane } = Tabs;

class ModalFacturarQuitarGlobal extends Component {
    formRef = React.createRef();

    state = {
        loading: false,
        datosVenta: undefined,
        todasClientes: null,
        objetoClientes: null,
        objetoUsosDeCFDI: null,
        todasUsosDeCFDI: null,
        modalElegirTipoDeCliente: false,
        modalElegirTipoDeClienteId: null,
        modalElegirTipoDeClienteNombre: null,
        modalCorreo: false,
        modalCorreoId: null,
        modalAgregarCliente: false,
        complementoDetallista: false,
        detallista: null,
        todasRegimenFiscal: null,
        objetoRegimenFiscal: null,
        activarRegimenes: false,
        contado: 2,
        objetoUsuarios: null,
    };

    componentDidUpdate(prevProps) {
        const becameVisible = !prevProps.visible && this.props.visible;
        const ventaCambio = prevProps.ventaId !== this.props.ventaId;
        if ((becameVisible || ventaCambio) && this.props.visible && this.props.ventaId) {
            this.formRef.current?.resetFields();
            this.setState(
                {
                    datosVenta: undefined,
                    todasClientes: null,
                    objetoClientes: null,
                    objetoUsosDeCFDI: null,
                    todasUsosDeCFDI: null,
                    complementoDetallista: false,
                    detallista: null,
                    modalElegirTipoDeCliente: false,
                    modalElegirTipoDeClienteId: null,
                    modalElegirTipoDeClienteNombre: null,
                    modalCorreo: false,
                    modalCorreoId: null,
                    todasRegimenFiscal: null,
                    objetoRegimenFiscal: null,
                    activarRegimenes: false,
                },
                () => this.consultarTodo()
            );
        }
    }

    async consultarTodo() {
        this.setState({ loading: true });
        try {
            const usosReq = axios.post(
                "usodecfdi/selectUsosDeCFDI",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            );

            const formasReq = axios.post(
                "formasDePago/selectFormasDePago",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            );

            const clientesReq = axios.post(
                "clientes/selectClientesIguales",
                { empresaId: this.props.empresaId, ventaId: this.props.ventaId },
                { headers: this.props.headersToken }
            );

            const ventaReq = axios.post(
                "ventas/datosVentaPRecibirP",
                { empresaId: this.props.empresaId, ventaId: this.props.ventaId },
                { headers: this.props.headersToken }
            );

            const regimenReq = axios.post(
                "ventas/selectDatosParaRegimen",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            );

            const usuariosReq = axios.post(
                "usuarios/selectUsuariosEmpresa",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            );

            const [usosRes, clientesRes, ventaRes, regimenRes, formasRes, usuariosRes] = await Promise.all([
                usosReq,
                clientesReq,
                ventaReq,
                regimenReq,
                formasReq,
                usuariosReq
            ]);

            if (usosRes?.data && usosRes.data.status !== 404) {
                const lista = usosRes.data;
                this.setState({
                    todasUsosDeCFDI: lista,
                    objetoUsosDeCFDI: lista.map((value) => (
                        <Option value={value._id} key={value._id}>
                            {value?.c_UsoCFDI + ' - ' + value.descripcion}
                        </Option>
                    )),
                });
            }

            if (usuariosRes?.data && usuariosRes.data.status !== 404) {
                const lista = usuariosRes.data;
                this.setState({
                    objetoUsuarios: lista.map((value) => (
                        <Option value={value._id} key={value._id}>
                            {value.nombre + ' ' + value.apellidoPaterno + ' ' + value.apellidoMaterno}
                        </Option>
                    )),
                });
            }

            if (formasRes?.data && formasRes.data.status !== 404) {
                const lista = formasRes.data;
                this.setState({
                    todasFormasDePago: lista,
                    objetoFormasDePago: lista.map((value) => (
                        <Option value={value._id} key={value._id}>
                            {value?.c_FormaPago + ' - ' + value.descripcion}
                        </Option>
                    )),
                });
            }

            if (clientesRes?.data && clientesRes.data.status !== 404) {
                const lista = clientesRes.data;
                this.setState({
                    todasClientes: lista,
                    objetoClientes: lista.map((value) => (
                        <Option value={value._id} key={value._id}>
                            {value.stringBuscar}
                        </Option>
                    )),
                });
            }

            if (!ventaRes?.data || ventaRes.data.status === 404) {
                message.error("Error: no se encontró información de la venta");
            } else {
                const v = ventaRes.data.venta;
                this.setState({
                    datosVenta: v,
                    contado: v.contado,
                    complementoDetallista: v.cliente.complementoDetallista,
                    detallista: {
                        orderIdentification: v.cliente.orderIdentification,
                        referenceDateOrderIdentification: v.cliente.referenceDateOrderIdentification,
                        additionalInformation: v.cliente.additionalInformation,
                        deliveryNote: v.cliente.deliveryNote,
                        referenceDateDeliveryNote: v.cliente.referenceDateDeliveryNote,
                    },
                });
                this.formRef.current?.setFieldsValue({
                    usoDeCfdiId: v.usoDeCfdiId,
                    formaDePagoId: v.formaDePagoId,
                    vendedorId: v.vendedorId,
                });
            }

            if (regimenRes?.data?.success === 2) {
                const { regimenesFiscales, activarRegimenes, regimenDefaultId } = regimenRes.data;
                this.setState({
                    objetoRegimenFiscal: regimenesFiscales.map((value) => (
                        <Option value={value._id} key={value._id}>
                            {value.c_RegimenFiscal + " - " + value.descripcion}
                        </Option>
                    )),
                    activarRegimenes,
                    todasRegimenFiscal: regimenesFiscales,
                });
                if (activarRegimenes) {
                    this.formRef.current?.setFieldsValue({ regimenFiscalId: regimenDefaultId });
                }
            } else {
                message.warning("No se encontraron datos de regímenes fiscales");
            }
        } catch (e) {
            message.error("Ocurrió un error al consultar datos");
        } finally {
            this.setState({ loading: false });
        }
    }

    onFinishFailed = (e) => {
        ErrorItem(e);
    };

    onFinish = (values) => {
        this.setState({ loading: true });
        axios
            .post(
                "ventas/facturarVentaDeGlobal",
                {
                    ...values,
                    empresaId: this.props.empresaId,
                    ventaId: this.props.ventaId,
                },
                { headers: this.props.headersToken }
            )
            .then(async (res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    if (res.data.messageSuccess) {
                        notification.warning({
                            description: "Revisar",
                            message: res.data.messageSuccess,
                            duration: 0,
                        });
                    }
                    message.success(res.data.messageSuccess || "Se ha generado la factura y se quitó de la factura global");
                    this.setState({ modalCorreo: true, modalCorreoId: res.data.ventaId });
                    this.printTicket(res.data);
                } else if (res.data.success === 1) {
                    MensajeError({
                      message: res.data.errorTimbrado?.titulo || res.data.message || "No se puede generar la factura",
                      description: res.data.errorTimbrado?.mensaje || res.data.description,
                      detalleTecnico: res.data.errorTimbrado?.detalleTecnico,
                    });
                } else {
                    message.error("Hubo un error y no se generó la factura");
                }
            })
            .catch(() => {
                this.setState({ loading: false });
                message.error("Error al generar la factura");
            });
    };

    printTicket = async (dataTicket) => {
        try {
            if (!this.props.impresoraSeleccionada) {
                throw new Error("No hay impresora seleccionada");
            }

            if (!qz.websocket.isActive()) {
                await qz.websocket.connect();
            }

            const config = await qz.configs.create(this.props.impresoraSeleccionada ? this.props.impresoraSeleccionada : "",
                {
                    encoding: 'Cp1252',
                    scaleContent: false,
                    rasterize: true,
                    density: 300
                }
            );

            const pdf2 = ticketPdf({ ...dataTicket, factura: true });
            const base64_1 = await new Promise((resolve) => {
                pdfMake.createPdf(pdf2).getBase64((base64) => resolve(base64));
            });

            await qz.print(config, [
                {
                    type: 'pixel',
                    format: 'pdf',
                    flavor: 'base64',
                    data: base64_1
                },
            ]);

            await qz.websocket.disconnect();
        } catch (err) {
            console.error('Error imprimiendo ticket:', err);
            const pdf2 = ticketPdf({ ...dataTicket, factura: true });
            pdfMake.createPdf(pdf2).getBlob((blob) => {
                const pdfURL = URL.createObjectURL(blob);

                const ua = navigator.userAgent || "";
                const isAndroid = /Android/i.test(ua);
                const isChromeiOS = /CriOS/i.test(ua);
                const isWebViewAndroid = isAndroid && /wv|Version\/\d+\.\d+.*Chrome\/\d+/i.test(ua);

                if (isAndroid || isWebViewAndroid || isChromeiOS) {
                    const win = window.open(pdfURL, "_blank");
                    if (!win) window.location.href = pdfURL;
                    setTimeout(() => URL.revokeObjectURL(pdfURL), 60000);
                    return;
                }

                try {
                    printJS({
                        printable: pdfURL,
                        type: "pdf",
                        showModal: false,
                    });
                } catch (e) {
                    message.error("No se pudo imprimir el ticket automáticamente. Cambie de navegador (por ejemplo, Chrome o Firefox).");
                    console.warn("printJS falló inmediatamente:", e);
                }

                setTimeout(() => URL.revokeObjectURL(pdfURL), 60000);
            });
        }
    };

    cerrar = () => {
        this.props.cerrarModalFacturarQuitarGlobal?.();
    };

    agregarCliente = () => {
        this.setState({ modalAgregarCliente: true });
    };

    cerrarAgregarCliente = (id) => {
        this.setState({ modalAgregarCliente: false });
        this.consultarTodo();
        if (id) {
            this.formRef.current?.setFieldsValue({ clienteFacturaId: id });
            this.onChangeCliente(id);
        }
    };

    onChangeCliente = (valueId) => {
        const cliente = this.state.todasClientes?.find((c) => c._id === valueId);
        if (!cliente) return;

        if (!cliente.regimenFiscalId || !cliente.direcciones[0]?.coloniaId) {
            message.info("No se podrá facturar a este cliente. Faltan datos");
        }
        if (!cliente.tipoClienteId) {
            const nombre = cliente.persona
                ? cliente.razonSocial
                : `${cliente.nombre} ${cliente.apellidoPaterno} ${cliente.apellidoMaterno}`;
            this.abrirElegirTipoDeCliente(cliente._id, nombre);
        }
        this.setState({
            complementoDetallista: cliente.complementoDetallista,
            detallista: {
                orderIdentification: cliente.orderIdentification,
                referenceDateOrderIdentification: cliente.referenceDateOrderIdentification,
                additionalInformation: cliente.additionalInformation,
                deliveryNote: cliente.deliveryNote,
                referenceDateDeliveryNote: cliente.referenceDateDeliveryNote,
            },
        });
        this.formRef.current?.setFieldsValue({
            usoDeCfdiId: cliente.usoDeCFDIID,
        });
    };

    abrirElegirTipoDeCliente = (id, nombre) => {
        this.setState({
            modalElegirTipoDeCliente: true,
            modalElegirTipoDeClienteId: id,
            modalElegirTipoDeClienteNombre: nombre,
        });
    };

    cerrarElegirTipoDeCliente = (elegido) => {
        if (!elegido) {
            this.formRef.current?.setFieldsValue({ clienteFacturaId: undefined });
        }
        this.consultarTodo();
        this.setState({
            modalElegirTipoDeCliente: false,
            modalElegirTipoDeClienteId: null,
            modalElegirTipoDeClienteNombre: null,
        });
    };

    cerrarMandarCorreo = () => {
        this.setState({
            modalCorreo: false,
            modalCorreoId: null,
        });
        this.formRef.current?.resetFields();
        this.cerrar();
    };

    onChangeCambiarCliente = (value) => {
        if (!value) {
            const c = this.state.datosVenta?.cliente;
            this.setState({
                complementoDetallista: c?.complementoDetallista,
                detallista: {
                    orderIdentification: c?.orderIdentification,
                    referenceDateOrderIdentification: c?.referenceDateOrderIdentification,
                    additionalInformation: c?.additionalInformation,
                    deliveryNote: c?.deliveryNote,
                    referenceDateDeliveryNote: c?.referenceDateDeliveryNote,
                },
            });
        } else {
            this.setState({ complementoDetallista: false });
        }
    };

    render() {
        const { visible } = this.props;
        const { datosVenta } = this.state;

        return (
            <Modal
                visible={visible}
                title={
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span>Facturar y Quitar de Factura Global</span>
                    </div>
                }
                onCancel={this.props.cerrarModalFacturarQuitarGlobal}
                footer={null}
                width={1000}
                maskClosable={false}
                destroyOnClose
                zIndex={1040}
                bodyStyle={{ paddingTop: 8, paddingBottom: 8, maxHeight: "70vh", overflow: "auto" }}
            >
                <Spin spinning={this.state.loading}>
                    <Form
                        ref={this.formRef}
                        name="facturarQuitarGlobalModal"
                        layout
                        bottom={
                            <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                                <ButtonItem onClick={this.cerrar} rojo>Cancelar</ButtonItem>
                                <Popconfirm
                                    title={"Se generara una nota de credito a PUBLICO GENERAL y se generará su propia factura. ¿Desea continuar?"}
                                    onConfirm={() => this.formRef.current.formRef.current.submit()}
                                    okText="Ok"
                                    cancelText="Cancelar"
                                >
                                    <ButtonItem morado type="primary">
                                        Facturar
                                    </ButtonItem>
                                </Popconfirm>
                            </div>
                        }
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <Tabs defaultActiveKey={1} size="small">
                            <TabPane tab="General" tabKey={1} key={1} forceRender>
                                <Row gutter={[16, 8]}>
                                    <Col span={24}>
                                        {this.state.activarRegimenes && (
                                            <>
                                                <HeaderItem>REGIMEN FISCAL</HeaderItem>
                                                <BoxItem>
                                                    <FormItem
                                                        label="Regimen Fiscal"
                                                        name="regimenFiscalId"
                                                        margin
                                                        required
                                                    >
                                                        <SelectItem placeholder="Regimen Fiscal">
                                                            {this.state.objetoRegimenFiscal}
                                                        </SelectItem>
                                                    </FormItem>
                                                </BoxItem>
                                            </>
                                        )}
                                        <HeaderItem>DATOS CLIENTE</HeaderItem>
                                        <BoxItem>
                                            <FormItem
                                                name="cambiarCliente"
                                                label="Cambiar Cliente"
                                                margin
                                                valuePropName="checked"
                                                initialValue={false}
                                            >
                                                <SwitchItem onChange={this.onChangeCambiarCliente} />
                                            </FormItem>

                                            <FormItem shouldUpdate noStyle>
                                                {({ getFieldValue }) => {
                                                    const cambiarCliente = getFieldValue("cambiarCliente");
                                                    if (cambiarCliente) {
                                                        return (
                                                            <FormItem margin label="Cliente">
                                                                <Input.Group compact>
                                                                    <FormItem name="clienteFacturaId" noStyle required>
                                                                        <SelectItem
                                                                            onChange={this.onChangeCliente}
                                                                            placeholder="Cliente"
                                                                            width="80%"
                                                                        >
                                                                            {this.state.objetoClientes}
                                                                        </SelectItem>
                                                                    </FormItem>
                                                                    <ButtonItem
                                                                        icon={<PlusOutlined />}
                                                                        style={{ width: "20%" }}
                                                                        onClick={this.agregarCliente}
                                                                    />
                                                                </Input.Group>
                                                            </FormItem>
                                                        );
                                                    }
                                                    return null;
                                                }}
                                            </FormItem>

                                            <FormItem name="usoDeCfdiId" label="Uso de CFDI" margin required>
                                                <SelectItem placeholder="Uso de CFDI">
                                                    {this.state.objetoUsosDeCFDI}
                                                </SelectItem>
                                            </FormItem>

                                            <FormItem name="formaDePagoId" label="Forma de Pago" margin required>
                                                <SelectItem disabled={this.state.contado !== 1} placeholder="Forma de Pago">
                                                    {this.state.objetoFormasDePago}
                                                </SelectItem>
                                            </FormItem>

                                            <FormItem
                                                label="Vendedor"
                                                name="vendedorId"
                                                margin
                                                required
                                            >
                                                <SelectItem placeholder="Vendedor">
                                                    {this.state.objetoUsuarios}
                                                </SelectItem>
                                            </FormItem>
                                        </BoxItem>
                                    </Col>
                                </Row>

                                <Divider style={{ marginBottom: 10, marginTop: 5 }} />

                                <Row>
                                    <Col span={16} xs={24} sm={24} lg={16} xl={16} />
                                    <Col span={8} xs={24} sm={24} lg={8} xl={8}>
                                        <h1 style={{ textAlign: "center", fontSize: 20 }}>Total Venta</h1>
                                        {datosVenta && (
                                            <table className="table">
                                                <tbody>
                                                    <tr>
                                                        <th className="th-totales" style={{ width: "50%" }}>
                                                            Subtotal
                                                        </th>
                                                        <td className="td-totales-right" style={{ width: "50%" }}>
                                                            {dineroDisabledMask(datosVenta.subtotal)}
                                                        </td>
                                                    </tr>
                                                </tbody>

                                                {datosVenta.arrayImpuestos?.map((valueArray) => (
                                                    <tbody key={valueArray.descripcionFactura}>
                                                        <tr>
                                                            <th className="th-totales">{valueArray.descripcionFactura}</th>
                                                            <td className="td-totales-right">
                                                                {dineroDisabledMask(valueArray.totalImpuestos)}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                ))}

                                                <tbody>
                                                    <tr>
                                                        <th className="th-totales">Total</th>
                                                        <td className="td-totales-right">
                                                            {dineroDisabledMask(datosVenta.total)}
                                                        </td>
                                                    </tr>
                                                </tbody>

                                                {datosVenta.arrayRetenciones?.map((valueArrayRet) => (
                                                    <tbody key={valueArrayRet.descripcionFactura}>
                                                        <tr>
                                                            <th className="th-totales">
                                                                {valueArrayRet.descripcionFactura}
                                                            </th>
                                                            <td className="td-totales-right">
                                                                {dineroDisabledMask(valueArrayRet.totalRetenciones)}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                ))}

                                                <tbody>
                                                    <tr>
                                                        <th className="th-totales">Total Pagar</th>
                                                        <td className="td-totales-right">
                                                            {dineroDisabledMask(datosVenta.totalPagar)}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        )}
                                    </Col>
                                </Row>
                            </TabPane>
                            <TabPane tab='CFDIs Relacionados' tabKey='4' key='4' forceRender>
                                <TabRelaciones />
                            </TabPane>

                            {this.state.complementoDetallista && this.props.complementoDetallista ? (
                                <TabPane tab="Detallista" tabKey={2} key={2} forceRender>
                                    {this.state?.detallista?.orderIdentification && (
                                        <FormItem
                                            name="orderIdentification"
                                            label="OrderIdentification"
                                            margin
                                            labelCol={{ span: 6 }}
                                            wrapperCol={{ span: 18 }}
                                            required
                                        >
                                            <InputItem placeholder="OrderIdentification" />
                                        </FormItem>
                                    )}

                                    {this.state?.detallista?.referenceDateOrderIdentification && (
                                        <FormItem
                                            name="referenceDateOrderIdentification"
                                            label="ReferenceDateOrderIdentification"
                                            margin
                                            labelCol={{ span: 6 }}
                                            wrapperCol={{ span: 18 }}
                                            required
                                        >
                                            <DatePickerItem placeholder="ReferenceDateOrderIdentification" />
                                        </FormItem>
                                    )}

                                    {this.state?.detallista?.additionalInformation && (
                                        <>
                                            <FormItem
                                                name="typeAdditionalInformation"
                                                label="TypeAdditionalInformation"
                                                margin
                                                labelCol={{ span: 6 }}
                                                wrapperCol={{ span: 18 }}
                                                required
                                            >
                                                <SelectItem placeholder="Type - AdditionalInformation">
                                                    <Option value="AAE">AAE - Cuenta predial</Option>
                                                    <Option value="CK">CK - Número de cheque</Option>
                                                    <Option value="ACE">ACE - Numero de documento(Remisión)</Option>
                                                    <Option value="ATZ">ATZ - Número de aprobación.</Option>
                                                    <Option value="AWR">AWR - Numero de documento que se reemplaza</Option>
                                                    <Option value="ON">ON - Número de pedido (comprador)</Option>
                                                    <Option value="DQ">DQ - Folio de recibo de mercancías</Option>
                                                    <Option value="IV">IV - Número de Factura</Option>
                                                </SelectItem>
                                            </FormItem>

                                            <FormItem
                                                name="referenceIdentificationAdditionalInformation"
                                                label="ReferenceIdentification"
                                                margin
                                                labelCol={{ span: 6 }}
                                                wrapperCol={{ span: 18 }}
                                                required
                                            >
                                                <InputItem placeholder="ReferenceIdentification - AdditionalInformation" />
                                            </FormItem>
                                        </>
                                    )}

                                    {this.state?.detallista?.deliveryNote && (
                                        <FormItem
                                            name="deliveryNote"
                                            label="DeliveryNote"
                                            margin
                                            labelCol={{ span: 6 }}
                                            wrapperCol={{ span: 18 }}
                                            required
                                        >
                                            <InputItem placeholder="DeliveryNote" />
                                        </FormItem>
                                    )}

                                    {this.state?.detallista?.referenceDateDeliveryNote && (
                                        <FormItem
                                            name="referenceDateDeliveryNote"
                                            label="ReferenceDateDeliveryNote"
                                            margin
                                            labelCol={{ span: 6 }}
                                            wrapperCol={{ span: 18 }}
                                            required
                                        >
                                            <DatePickerItem placeholder="ReferenceDateDeliveryNote" />
                                        </FormItem>
                                    )}
                                </TabPane>
                            ) : null}
                        </Tabs>
                    </Form>
                </Spin>

                <ElegirTipoDeCliente
                    visible={this.state.modalElegirTipoDeCliente}
                    id={this.state.modalElegirTipoDeClienteId}
                    nombre={this.state.modalElegirTipoDeClienteNombre}
                    cerrarElegirTipoDeCliente={this.cerrarElegirTipoDeCliente}
                />

                <MandarCorreo
                    zIndex={1200}
                    visible={this.state.modalCorreo}
                    id={this.state.modalCorreoId}
                    cerrarMandarCorreo={this.cerrarMandarCorreo}
                />

                <AgregarCliente
                    visible={this.state.modalAgregarCliente}
                    cerrarModal={this.cerrarAgregarCliente}
                    zIndex={1200}
                />
            </Modal>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    complementoDetallista: state.empresa.complementoDetallista,
});

export default connect(mapStateToProps)(ModalFacturarQuitarGlobal);
